import { render, staticRenderFns } from "./ConInsure.vue?vue&type=template&id=95d6a5ce&scoped=true"
import script from "./ConInsure.vue?vue&type=script&lang=js"
export * from "./ConInsure.vue?vue&type=script&lang=js"
import style0 from "./ConInsure.vue?vue&type=style&index=0&id=95d6a5ce&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95d6a5ce",
  null
  
)

export default component.exports